import { render, staticRenderFns } from "./AlphabetTable.vue?vue&type=template&id=fbf77c78&scoped=true"
import script from "./AlphabetTable.vue?vue&type=script&lang=js"
export * from "./AlphabetTable.vue?vue&type=script&lang=js"
import style0 from "./AlphabetTable.vue?vue&type=style&index=0&id=fbf77c78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf77c78",
  null
  
)

export default component.exports